module.exports = {
          srcSet: __webpack_public_path__ + "public/images/3e2f46ad9afb72e30b84398710b20a71-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/3e2f46ad9afb72e30b84398710b20a71-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/3e2f46ad9afb72e30b84398710b20a71-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/3e2f46ad9afb72e30b84398710b20a71-1774.webp"},
          
          width: 1774,
          height: 887
        }